import { render, staticRenderFns } from "./PopupAddCampaign.vue?vue&type=template&id=2450d383&scoped=true&"
import script from "./PopupAddCampaign.vue?vue&type=script&lang=js&"
export * from "./PopupAddCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2450d383",
  null
  
)

export default component.exports